import { usePageExperienceContext } from './usePageExperienceContext';

// The experience that owns shared state (permissions, etc.). When a planner is rendered
// via a printable child, the context experience is the child; its parent planner is the
// real owning entity.
export const useEffectiveExperience = () => {
  const { experience, parentExperience } = usePageExperienceContext();
  return parentExperience || experience;
};
